var MultimediaBlockView = require('views/block/multimedia-block-view');
var AudioService = require('services/audio-service');
var CourseSettingsService = require('services/course-settings-service');
import { MemoryStorageService } from 'services/web-storage-service';
var LocaleService = require('services/locale-service');
const AhoyService = require('services/ahoy-service');
import ProgressEvent from 'views/block/audio/progress-event';

var AudioView = MultimediaBlockView.extend({
  load: function () {
    let template = this.model.get('template');
    this.loaded = false;
    AudioService.load(this.model.get('audio_id')).done(_.bind(this.soundLoaded, this));
    this.cid = this.model.get('cid');
    var self = this;

    this.initValues();

    this.delegate('click', `#${this.model.get('cid')}-audioButton`, function () {
      self.buttonClicked = true;
      var state = self.model.get('audio_status');
      if (state === 'paused') {
        self.resume();
      } else if (state === 'playing') {
        self.pause();
      } else if (state === 'stopped' || state === 'completed') {
        self.play();
      }
    });

    this.delegate('click', `#muteBtn`, this.toggleMute);

    this.delegate('click', `#audioDuration`, this.toggleRemaining);
    this.delegate('click', `#audioRemaining`, this.toggleRemaining);

    this.delegate('change', `#audioController`, e => {
      this.sound.volume = $(e.currentTarget).find('.volumebar').val();
      this.model.set('audio_volume', this.sound.volume);
      if (this.sound.volume <= 0) {
        this.mute();
      } else {
        this.unmute();
      }
    });

    this.listenTo(this.model, 'change:audio_status', () => {
      if (this.model.get('audio_status') === 'playing') {
        const audioSettings = CourseSettingsService.get('audio');
        const delay = audioSettings && audioSettings.progressDelay ? audioSettings.progressDelay : 700;

        this.dispatchProgressEvent(); // playing just started, send out event immediatly

        this.progressInterval = setInterval(() => {
          // also dispatch very `delay` ms
          this.dispatchProgressEvent();
        }, delay);
      } else if (this.model.get('audio_status') === 'completed') {
        this.dispatchProgressEvent(); // send out one final event since the audio is at 100%
        this.stopProgressInterval();
      } else {
        this.stopProgressInterval();
      }

      this.model.set('display_status', LocaleService.t('audioAccessibility.' + this.model.get('audio_status')));
      Chaplin.mediator.publish(
        'media:status:changed',
        this.model.get('audio_status'),
        this.model.get('audio_id'),
        'audio',
        this.model.get('background')
      );

      // Avoids reRender when the progress-bar template is being used
      if (template === 'progress-bar') {
        this.updateDisplay();
      } else {
        const shouldRefocus =
          document.activeElement === this.$el.find(`#${this.model.get('cid')}-audioButton`).get()[0];
        this.reRender();
        shouldRefocus && this.$el.find(`#${this.model.get('cid')}-audioButton`)[0].focus({ preventScroll: true });
        this.$(`#${this.model.get('cid')}-audioButton`).attr(
          'aria-label',
          LocaleService.t('audioAccessibility.aria-' + this.model.get('audio_status'))
        );
      }
    });
    var playEvent = () => {
      this.buttonClicked = true;
      this.play();
    };
    Chaplin.mediator.subscribe(`audio:play:${this.model.get('audio_id')}`, playEvent, this);
    Chaplin.mediator.subscribe(`media:play:${this.model.get('audio_id')}`, playEvent, this);
    Chaplin.mediator.subscribe(`audio:progress:${this.model.get('audio_id')}`, progress => {
      if (this.model) {
        this.setInner(progress.formatedTimes());
      }
    });
  },
  updateDisplay: function () {
    let audio_status = this.model.get('audio_status');
    let display_status = this.model.get('display_status');
    let audio_states = 'playing paused stopped completed';

    this.$(`#audioController, #${this.model.get('cid')}-audioButton`)
      .removeClass(audio_states)
      .addClass(audio_status);
    this.$(`#${this.model.get('cid')}-audioButton`).attr('data-state', audio_status);
    if (audio_status === 'stopped' || audio_status === 'completed') {
      this.$(`#${this.model.get('cid')}-audioButton`)
        .removeClass('hide-audio-text')
        .text(display_status);
    } else {
      this.$(`#${this.model.get('cid')}-audioButton`)
        .addClass('hide-audio-text')
        .fadeOut(700, function () {
          $(this).empty().fadeIn(300);
        });
    }
  },
  dispatchProgressEvent: function () {
    Chaplin.mediator.publish(
      `audio:progress:${this.model.get('audio_id')}`,
      new ProgressEvent(this.sound.position, this.sound.duration, this.sound.muted)
    );
  },
  soundLoaded: function (sound) {
    if (!this.disposed) {
      this.sound = sound;
      this.loaded = true;
      if (this.playCalled) {
        this.playSound();
        this.playCalled = false;
      }
    }
  },
  play: function () {
    this.unmute();
    let shouldPlay = this.model.get('auto_play') !== false || this.buttonClicked;
    if (this.model.get('auto_play') !== false && this.model.get('auto_play_times')) {
      var plays = MemoryStorageService.getItem(`${this.model.get('audio_id')}:plays`) || 0;
      if (plays < this.model.get('auto_play_times')) {
        plays++;
        MemoryStorageService.setItem(`${this.model.get('audio_id')}:plays`, plays);
        shouldPlay = true;
      } else {
        shouldPlay = false;
      }
    }
    if (shouldPlay) {
      if (this.loaded) {
        this.playSound();
      } else {
        this.playCalled = true;
      }
    } else {
      this.model.set('audio_status', 'stopped');
    }

    var audioMin = this.model.get('override') || CourseSettingsService.get('audioMinimum');

    if (this.model.get('state') !== 'completed') {
      if (!this.model.get('required') && !audioMin) {
        this.readyToGo();
      } else if (audioMin && !this.model.get('required')) {
        setTimeout(_.bind(this.readyToGo, this), parseInt(audioMin));
      }
    }
  },
  initValues: function () {
    // Initialize timers
    this.setTime('position');
    this.setTime('duration');
    this.model.set('display_remaining', false);
    this.setTime('remaining');
    this.model.set('audio_volume', 1);
    this.model.set('muted', false);
  },
  playSound: function () {
    Chaplin.mediator.publish('media:narration', LocaleService.t(this.model.get('narration')));

    this.subscribeEvent('media:play', (assetId, isBackground) => {
      if (!isBackground && assetId !== this.model.get('audio_id') && this.sound && !this.model.get('background')) {
        this.sound.paused = true;
        this.sound.stop();
        this.sound.off('succeeded', this.onSucceeded);
        this.sound.off('failed', this.onFailed);
        this.model.set('audio_status', 'stopped');
      }
    });
    Chaplin.mediator.publish('media:play', this.model.get('audio_id'), this.model.get('background'));
    Chaplin.mediator.publish(`media:playing:${this.model.get('audio_id')}`);
    Chaplin.mediator.publish(`audio:playing:${this.model.get('audio_id')}`);

    if (!this.model.get('background')) {
      this.onFailed = this.sound.on('failed', () =>
        Chaplin.mediator.publish('audio:play:failed', this.model.get('audio_id'))
      );
    }
    this.onSucceeded = this.sound.on('succeeded', () => {
      if (Object.isExtensible(this)) {
        this.failureTimeOutId = setTimeout(() => {
          if (this.sound.position < 10) {
            this.sound.playState = createjs.Sound.PLAY_FAILED;
            if (!this.model.get('background')) {
              Chaplin.mediator.publish('audio:play:failed', this.model.get('audio_id'));
            }
          }
        }, 100);
      }
    });

    this.onComplete = this.sound.on(
      'complete',
      function () {
        //Chaplin.mediator.publish('media:mutable', false);
        Chaplin.mediator.publish('media:narration', false);
        if (this.model) {
          this.model.set('audio_status', 'completed');
          if (this.model.get('required')) {
            this.readyToGo();
          }
          Chaplin.mediator.publish('media:ended', this.model.get('audio_id'));
          Chaplin.mediator.publish('media:ended:' + this.model.get('audio_id'));
          Chaplin.mediator.publish('audio:ended:' + this.model.get('audio_id'));
          AhoyService.track('audio', { action: 'completed', audio_id: this.model.get('audio_id') });
        }
      },
      this,
      true
    );

    if (
      createjs.WebAudioPlugin.context &&
      createjs.WebAudioPlugin.context.state === 'suspended' &&
      !this.model.get('background')
    ) {
      Chaplin.mediator.publish('audio:play:failed', this.model.get('audio_id'));
    } else {
      var loop = this.model.get('loop');
      if (loop !== undefined) {
        if (loop === true) {
          this.sound.play({ loop: -1 });
        } else if (Number.isInteger(loop)) {
          this.sound.play({ loop: loop - 1 }); //loop is 0 indexed
        } else {
          this.sound.play();
        }
      } else {
        this.sound.play();
      }
      if (EF.enrollment.getData('muted') === 'on') {
        this.mute();
      } else {
        this.unmute();
      }

      this.model.set('audio_status', 'playing');
      AhoyService.track('audio', { action: 'playing', audio_id: this.model.get('audio_id') });
    }
  },
  pause: function () {
    if (this.sound && this.model.get('audio_status') === 'playing') {
      this.sound.paused = true;
      this.model.set('audio_status', 'paused');
      AhoyService.track('audio', { action: 'pause', audio_id: this.model.get('audio_id') });
    }
  },
  resume: function () {
    if (this.sound && this.model.get('audio_status') === 'paused') {
      this.sound.paused = false;
      this.model.set('audio_status', 'playing');
      AhoyService.track('audio', { action: 'resume', audio_id: this.model.get('audio_id') });
    }
  },
  mute: function () {
    if (this.sound) {
      this.sound.muted = true;
      this.$(`#iconMute`).removeClass('icon-mute-off').addClass('icon-mute-on');
      Chaplin.mediator.publish('media:mute:change', 'on');
      AhoyService.track('audio', { action: 'mute', audio_id: this.model.get('audio_id') });
    }
  },
  unmute: function () {
    if (this.sound) {
      this.sound.muted = false;
      this.$(`#iconMute`).removeClass('icon-mute-on').addClass('icon-mute-off');
      Chaplin.mediator.publish('media:mute:change', 'off');
      AhoyService.track('audio', { action: 'unmute', audio_id: this.model.get('audio_id') });
    }
  },
  toggleMute: function () {
    if (this.sound) {
      if (this.sound.muted) {
        this.unmute();
      } else {
        this.mute();
      }
      this.model.set('muted', this.sound.muted);
    }
  },
  replay: function () {
    this.playSound();
  },
  stopProgressInterval: function () {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  },
  setTime: function (setter, valueInSeconds = '00:00') {
    this.model.set(setter, valueInSeconds);
  },
  setInner: function (formatedTimes) {
    this.$(`#audioTime`).html(formatedTimes.position);
    this.$(`#audioDuration`).html(formatedTimes.duration);
    this.$(`#audioRemaining`).html(formatedTimes.remaining);
    // This will save values when reRenders get triggered
    this.setTime('position', formatedTimes.position);
    this.setTime('duration', formatedTimes.duration);
    this.setTime('remaining', formatedTimes.remaining);
  },
  toggleRemaining() {
    let displayRemaining = this.model.get('display_remaining');
    this.model.set('display_remaining', !displayRemaining);
    this.$(`.duration-display`).toggleClass('hidden');
  },
  dispose: function () {
    if (this.sound) {
      this.sound.paused = true;
      this.sound.stop();
      this.model.set('audio_status', 'stopped');
      this.sound.off('complete', this.onComplete);
      this.sound.off('succeeded', this.onSucceeded);
      this.sound.off('failed', this.onFailed);
    }

    this.stopProgressInterval();

    if (this.failureTimeOutId) {
      clearTimeout(this.failureTimeOutId);
      delete this.failureTimeOutId;
    }

    MultimediaBlockView.prototype.dispose.apply(this, arguments);
  },
});

module.exports = AudioView;
